import React from 'react';
import { BaasicTextAreaTemplate } from 'themes/components';

function BaasicTextArea(props) {
	return <BaasicTextAreaTemplate {...props} />;
}

export default BaasicTextArea;



// WEBPACK FOOTER //
// ./src/core/components/forms/BaasicTextArea.js